export { default } from './QuotationsInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/QuotationsInfo/index.js